import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface-100 border-t border-white/10 mt-auto">
      <div className="container-custom py-10">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 text-sm">
          <div>
            <p className="text-gray-300 font-medium font-display">
              Latchiya Software Systems Pvt Ltd
            </p>
            <p className="mt-3 text-gray-400 leading-relaxed max-w-sm">
              Bangalore, India
            </p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs tracking-wide mb-2">
              Contact
            </p>
            <p className="text-gray-300">
              <a
                href="tel:+919945101015"
                className="hover:text-white transition-colors"
              >
                +91 99451 01015
              </a>
            </p>
            <p className="mt-1">
              <a
                href="mailto:support@latchiya.com"
                className="text-primary-300 hover:text-primary-200 transition-colors"
              >
                support@latchiya.com
              </a>
            </p>
          </div>
          <div>
            <p className="text-gray-500 uppercase text-xs tracking-wide mb-2">
              Explore
            </p>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link
                  to={{ pathname: '/', hash: '#company' }}
                  className="hover:text-white transition-colors"
                >
                  Company
                </Link>
              </li>
              <li>
                <Link
                  to={{ pathname: '/', hash: '#products' }}
                  className="hover:text-white transition-colors"
                >
                  Products
                </Link>
              </li>
              <li>
                <Link
                  to={{ pathname: '/', hash: '#careers' }}
                  className="hover:text-white transition-colors"
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <p className="mt-10 pt-8 border-t border-white/10 text-gray-500 text-sm">
          {year} · Latchiya Software Systems. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
